import React from 'react';
import {postApi, deleteApi} from '../../../utils/functions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import axios from 'axios';
//import Gallery from 'react-photo-gallery';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import ProgressBar from 'react-bootstrap/ProgressBar';
import Modal from 'react-bootstrap/Modal';

import './upload.css';
import { ButtonGroup } from 'react-bootstrap';

export default class UploadFile extends React.Component {
	constructor(props) {
    super(props);
		this.state = {
			show: false,
			showModal: false,
			src: this.props.src,
			default: (this.props.src.indexOf('_default_')>-1||this.props.src==='components/user.png')?true:false,
			files: [],


			percent: -1,
			failed: 0,
			deleteFile: '',
			/* The rest are to check*
			uid: this.props.uid,

			filename: '',
			
			gallery: [],*/
		};
		this.gatherFiles = this.gatherFiles.bind(this);
		this.clickuploadFile = this.clickuploadFile.bind(this);
		this.uploadFiles = this.uploadFiles.bind(this);
		this.openModal = this.openModal.bind(this);
		this.selectUpload = this.selectUpload.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
		this.close = this.close.bind(this);
		/*
		this.uploadFile = this.uploadFile.bind(this);
		this.close = this.close.bind(this);
		this.Image = this.Image.bind(this);
		this.deleteImage = this.deleteImage.bind(this);*/
	}

	async componentDidMount() {
		await this.gatherFiles();
	}

	componentWillUnmount() {
	}

	async gatherFiles() {
		let params = new URLSearchParams();
		params.append('path', this.props.path);
		const x = await postApi('/v3/upload', params);
		let src = this.state.src;
		let def = this.state.default;
		if( def === true && x.data.length > 0 ) {
			src = this.props.path + x.data[0].filename;
			def = false;
			this.selectUpload(x.data[0].filename);
		}
		this.setState({show: true, files: x.data, src, default: def});
	}

	clickuploadFile() {
		document.getElementById('upload').click();
	}

	
	async uploadFiles(event) {
		const params = new FormData();
		params.append('path',this.props.path);
		const selectedFiles = event.target.files;
		for (let i = 0; i < selectedFiles.length; i++) {
			params.append('files',selectedFiles[i]);
		}
		let x = await axios.put(`/v3/upload`, params, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true,
			onUploadProgress: (progressEvent) => {
				let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
				this.setState({percent: percentCompleted});
			}
		});
		this.setState({percent: -1, failed: x.data.failed},()=>{
			this.gatherFiles();
		});
	}


	async openModal() {
		this.setState({showModal: !this.state.showModal, deleteFile: ''});
	}


	async selectUpload(name) {
		this.setState({src: name});
		this.props.onChange(name);
		this.close();
	}


	async deleteFile(name) {
		if( name === this.state.deleteFile ) {
			let params = new URLSearchParams();
			params.append('path', this.props.path);
			params.append('filename', name);
			
			//let x = 
			await deleteApi(`/v3/upload`, params);
			this.props.onChange('');
			await this.gatherFiles();
		} else {
			this.setState({deleteFile: name});
		}
	}


	close() {
		this.setState({ showModal: false });
	}


	render() {
		const files = Object.keys(this.state.files).map((e,i) => {
			let type = this.state.files[e].type.indexOf('/')?this.state.files[e].type.split('/')[0]:this.state.files[e].type;
			return (
				<Col xs={12} sm={6} md={4} lg={3} key={i}>
					<div className="avatar-outline">
						{type==='image' &&
							<>
								<img src={`https://cloud.ultrastream.io/images/${this.props.path}${this.state.files[e].filename}`} width={'100%'} onClick={()=>this.selectUpload(`${this.props.path}${this.state.files[e].filename}`)} className="avatar-outline-fit" alt="file" />
							</>
						}

						<div style={{position: 'absolute', right: 10, bottom: 10}}>
							<ButtonGroup size="sm">
								{this.state.src === this.props.path + this.state.files[e].filename &&
									<Button size="sm" variant="success"><FontAwesomeIcon icon="check" /></Button>
								}
								{this.state.deleteFile === this.state.files[e].filename ?
									<>
										<Button size="sm" variant="danger" onClick={()=>this.deleteFile(this.state.files[e].filename)}><FontAwesomeIcon icon="trash" /> DELETE</Button>
									</>
								:
									<>
										<Button size="sm" className="bg-purple-gradient" onClick={()=>this.deleteFile(this.state.files[e].filename)}><FontAwesomeIcon icon="trash" /></Button>
									</>
								}
							</ButtonGroup>
						</div>
					</div>
				</Col>
			)
		});
		return (
			<>
				{this.state.show &&
					<>
						{this.state.default === true ?
							<div style={{position: 'relative'}}>
								<img src={`https://cloud.ultrastream.io/images/components/upload.png`} width={360} style={{marginRight: 10, cursor: 'pointer'}} onClick={()=>this.clickuploadFile()} alt="upload" />
								{this.state.percent>=0 &&
									<div className="upload-progress">
										<div className="progress progress-sm progress-custom mb-5 progress-animate" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
											{this.state.percent>=100 ?
												<div className="progress-bar bg-warning" style={{width: `${this.state.percent}%`}}>
													<div className="progress-bar-value bg-warning">Completing</div>
												</div>
											:
												<div className="progress-bar bg-success" style={{width: `${this.state.percent}%`}}>
													<div className="progress-bar-value bg-success">{this.state.percent}%</div>
												</div>
											}
										</div>
									</div>
								}
							</div>
						:
							<img src={this.state.src.indexOf('https://')===0?this.state.src:`https://cloud.ultrastream.io/images/${this.state.src}`} width={140} style={{marginRight: 10, cursor: 'pointer'}} onClick={()=>this.openModal()} alt="avatar" crossOrigin="" /*use-credentials*/ />
						}
					</>
				}
				
			
			
				<Modal show={this.state.showModal} onHide={this.openModal} backdrop="static" keyboard={false} size="xl" centered>
					<Modal.Header closeButton className="">
						<Modal.Title>Upload File(s)</Modal.Title>
					</Modal.Header>
					<Modal.Body className="">

					
						<div className="upload-image">
							<div className="d-flex align-items-center mb-3">
								<div style={{position: 'relative'}}>
									<img src={`https://cloud.ultrastream.io/images/components/upload.png`} width={360} style={{marginRight: 10, cursor: 'pointer'}} onClick={()=>this.clickuploadFile()} alt="Upload File" />
									{this.state.percent>=0 &&
									<div className="upload-progress">
										<div className="progress progress-sm progress-custom mb-5 progress-animate" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
											{this.state.percent>=100 ?
												<div className="progress-bar bg-warning" style={{width: `${this.state.percent}%`}}>
													<div className="progress-bar-value bg-warning">Completing</div>
												</div>
											:
												<div className="progress-bar bg-success" style={{width: `${this.state.percent}%`}}>
													<div className="progress-bar-value bg-success">{this.state.percent}%</div>
												</div>
											}
										</div>
									</div>
								}
								</div>
								<div>
									<div className="upload-file-info">
										<div className="float-right">
											{/*this.state.percent>0&&`${this.state.percent}%`*/}
										</div>
										<div className="">
											{/*this.state.filename.length>0?this.state.filename.substring(0,40):`Click to upload file`*/}<br />
											Max 10 files<br />
											Best keeping Logo's and Profile Avatars similar in width and height<br />
											<span className="badge rounded-pill bg-danger-transparent">
												{this.state.failed > 0 && <>{this.state.failed} file(s) failed to upload</>}
											</span>
										</div>
										{/*<div className="">
											<ProgressBar animated now={this.state.percent} />
										</div>*/}
									</div>
								</div>
							</div>
						</div>
						<Row className="gx-0">
							{files}
						</Row>

					</Modal.Body>
					<Modal.Footer className="">
						<Button variant="secondary" onClick={this.openModal}>
							Close
						</Button>
						{this.state.access&&
							<Button variant="primary" onClick={this.submitEvent}>Add Event</Button>
						}
					</Modal.Footer>
				</Modal>
				<input id="upload" type="file" onChange={this.uploadFiles} style={{display: 'none'}} />
			</>
		)
	}
}